/* eslint-disable camelcase */
/* eslint-disable no-trailing-spaces */
/* eslint-disable padded-blocks */
/* eslint-disable indent */

const tabClick = ($tab_selector, $tab_section) => {
    //  Determine the target section to show
    const target_id = $tab_selector.getAttribute('tab-selector');
    const $target_elements = document.querySelectorAll(`[tab-content="${target_id}"]`);
    $target_elements.forEach((element) => {
        element.classList.remove('tab-active');
    });

    const current_active = $tab_section.getElementsByClassName('tab-active');
    for (let i = 0; i < current_active.length; i += 1) {
        const $current_active_tab = current_active[i];
        $current_active_tab.classList.remove('tab-active');
        const current_active_section_id = $current_active_tab.getAttribute('tab-selector');
        const $targets = document.querySelectorAll(`[tab-content="${current_active_section_id}"]`);
        $targets.forEach((element) => {
            element.classList.remove('tab-active');
        });
    }

    //  Apply the active class to tab and target element
    $tab_selector.classList.add('tab-active');
    $target_elements.forEach((element) => {
        element.classList.add('tab-active');
    });

    const tab_section_name = $tab_section.getAttribute('tab-section');
    const tab_name = $tab_selector.getAttribute('tab-selector');

    //  Save to session storage
    sessionStorage.setItem(`kw_tab_section_${tab_section_name}_active`, tab_name);

};

export const initTabSection = () => {

    //  Get each tab section on the page
    const tab_sections = document.querySelectorAll('[tab-section]');

    for (let i = 0; i < tab_sections.length; i += 1) {

        //  Define the tab section
        const $tab_section = tab_sections[i];

        //  Get the tab selectors
        const tab_selectors = $tab_section.querySelectorAll('[tab-selector]');

        //  Check session storage for the active tab
        const tab_section_name = $tab_section.getAttribute('tab-section');
        if (sessionStorage.getItem(`kw_tab_section_${tab_section_name}_active`)) {
            const active_tab_name = sessionStorage.getItem(`kw_tab_section_${tab_section_name}_active`);
            const $active_tab_selector = $tab_section.querySelector(`[tab-selector="${active_tab_name}"]`);

            if ($active_tab_selector !== null) {
                tabClick($active_tab_selector, $tab_section);
            }
            
        }

        //  Make sure there is an active selection, if not, activate the first tab
        const current_active = $tab_section.querySelector('[tab-selector].tab-active');
        if (current_active == null) {
          tabClick($tab_section.querySelector('[tab-selector]'), $tab_section);
        }
        
        for (let ii = 0; ii < tab_selectors.length; ii += 1) {
            const $tab_selector = tab_selectors[ii];

            //  On click of tab selector
            $tab_selector.addEventListener('click', (e) => {
                e.preventDefault();
                tabClick($tab_selector, $tab_section);
            });

        }
    }
};  
export default 'initTabSection';
